/**
 * Analytics / tracker correlation id — crypto tabanlı (Sonar: Math.random güvenli değil).
 */
let fallbackLastMs = 0
let fallbackSeq = 0

function nextFallbackRequestId(): string {
  const now = Date.now()
  if (now !== fallbackLastMs) {
    fallbackLastMs = now
    fallbackSeq = 0
  }
  fallbackSeq += 1
  return `req-${now}-${fallbackSeq}`
}

export function getAnalyticsRequestId(): string {
  const c = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID()
  }
  if (c && typeof c.getRandomValues === 'function') {
    const bytes = new Uint8Array(16)
    c.getRandomValues(bytes)
    return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  }
  return nextFallbackRequestId()
}
